import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-penyimpangan',
  templateUrl: './penyimpangan.component.html',
  styleUrls: ['./penyimpangan.component.scss'],
})
export class PenyimpanganComponent {
  constructor(public api: ApiService) {}

  dismiss() {
    this.api.dismiss();
  }
}
